import { useAdvisorsQuery } from "web_myplann/Api/Advisor/useAdvisorsQuery";

export const useAdvisorsList = () => {
	const { data, isLoading } = useAdvisorsQuery();

	return {
		connectedAdvisors: data?.connectedAdvisors ?? [],
		pendingAdvisors: data?.pendingAdvisors ?? [],
		advisorsPending: data?.advisorsPending,
		isLoading,
	};
};
